module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aVpBM"))).then(() => module.bundle.root('5erN3'));